import { DocumentStatus } from '../../../../../api/enumerations';

export const getDocumentStatusColor = (status: DocumentStatus): string => {
  if (status === DocumentStatus.APPROVED) return '#00B39B';
  if (status === DocumentStatus.REJECTED) return '#F90B0B';
  return '#FF6600';
};

// Preview em texto puro do motivo de rejeição (que agora é rich text/HTML):
// remove as tags para a prévia na célula da tabela. O texto completo formatado
// é exibido no diálogo (RichTextViewer).
export const stripHtml = (html: string | null | undefined): string =>
  (html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
